import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import StandardMenu from './StandardMenu';
import StandardMenuBranched from '../StandardMenu.updated_menu';
export default withFeatureBranch({
    updated_menus: StandardMenuBranched
})(StandardMenu);
